<template>
	<span
		class="px-6 py-2 text-sm font-normal rounded whitespace-nowrap"
		:class="outlined ? 'bg-transparent text-gray-400 border border-gray-500' : 'bg-gray-600 text-gray-200'"
	>
		<slot />
	</span>
</template>
<script>
export default {
	name: 'BasePill',
	props: {outlined: Boolean},
}
</script>
